module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_15.3e16a7b3.png";